import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { useModal } from '@tager/web-components';

import { ReactComponent as FilterIcon } from '@/assets/svg/Catalog/filter.svg';
import useModalsOpen from '@/hooks/useModalsOpen';
import { Filter } from '@/components/Filter/Filter';

type Props = {
  productId: number;
  productAlias: string;
  productsCount?: number;
};

const FilterBtn: React.FC<Props> = ({
  productId,
  productsCount,
  productAlias,
}) => {
  const openModal = useModal();
  const { openModalState } = useModalsOpen();

  const onClick = () => {
    openModalState();
    openModal(
      Filter,
      { productId, productsCount, productAlias },
      { withAnimation: false, scrollLockDisabled: true }
    );
  };

  const t = useTranslations();

  return (
    <Component onClick={onClick}>
      <Icon>
        <FilterIcon />
      </Icon>
      <Title>{t('filter.title')}</Title>
    </Component>
  );
};

const Component = styled.div`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;

  border: 1px solid #860935;
  box-sizing: border-box;
  border-radius: 5px;
`;

const Icon = styled.span`
  line-height: 0;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #870a36;

  margin-left: 9px;
`;

export default FilterBtn;
